/**
 * Alpine component for the certificate and CEU download forms.
 *
 * Posts the form with fetch() so the page stays put, saves the PDF from the
 * response, then clears the spinner. Anything other than a PDF response falls
 * back to a normal form submit.
 */
const filenameFrom = (disposition) => {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition || '')
  return match ? decodeURIComponent(match[1]) : 'download.pdf'
}

export default () => ({
  busy: false,

  async download(event) {
    const form = event.target

    if (this.busy) {
      return
    }

    this.busy = true

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      })
      const contentType = response.headers.get('Content-Type') || ''

      if (!response.ok || !contentType.includes('application/pdf')) {
        throw new Error(`Expected a PDF, got ${response.status} ${contentType}`)
      }

      const url = URL.createObjectURL(await response.blob())
      const link = document.createElement('a')

      link.href = url
      link.download = filenameFrom(response.headers.get('Content-Disposition'))
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch (error) {
      console.error(error)
      form.submit()
    } finally {
      this.busy = false
    }
  },
})
